import React, { useEffect, useRef } from 'react';

declare const flatpickr: any;

interface DateFieldProps {
  value: string;
  onChange: (v: string) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
}

export const DateField: React.FC<DateFieldProps> = ({ value, onChange, className, placeholder, disabled }) => {
  const ref = useRef<HTMLInputElement>(null);
  const fpRef = useRef<any>(null);

  useEffect(() => {
    if (!ref.current || typeof flatpickr === 'undefined' || disabled) return;
    fpRef.current = flatpickr(ref.current, {
      dateFormat: 'Y-m-d',
      defaultDate: value || undefined,
      allowInput: true,
      onChange: (_selectedDates: Date[], dateStr: string) => onChange(dateStr),
    });
    return () => { fpRef.current?.destroy(); fpRef.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  useEffect(() => {
    if (fpRef.current && value !== undefined) {
      fpRef.current.setDate(value, false);
    }
  }, [value]);

  return (
    <div className="input-group input-group-merge">
      <input
        ref={ref}
        type="text"
        className={className || 'form-control form-control-sm'}
        defaultValue={value}
        placeholder={placeholder || 'YYYY-MM-DD'}
        readOnly={disabled}
        disabled={disabled}
      />
      {!disabled && (
        <span className="input-group-text">
          <i className="ri-calendar-line"></i>
        </span>
      )}
    </div>
  );
};
